import React, { useMemo, useState } from 'react';
import FaIcon from '../FaIcon';
import RoleService from '../../Services/roleService';
import ReportLauncherCard from './ReportLauncherCard';
import { filterSectionsByPermission, filterSectionsByQuery, countCards } from './reportLauncherHelper';

// Generic launcher page (CD-5241): grouped card sections + live search + count
// readout fixed into the shell's 80px header band (mirrors .blist-actions).
// Callers own their modals — pass them via `overlay`. Cards whose roleKey fails
// the permission check are dropped here (tallies/count reflect visible cards).
function ReportLauncherPage({
  sections,
  searchPlaceholder = 'Search reports…',
  countNoun = 'reports',
  roleContext = 'ButtonRowButton',
  overlay = null,
}) {
  const [query, setQuery] = useState('');

  const visibleSections = useMemo(
    () => filterSectionsByPermission(sections, (roleKey) => RoleService.CheckUserPermission(roleContext, roleKey)),
    [sections, roleContext]
  );
  const total = countCards(visibleSections);
  const filteredSections = useMemo(() => filterSectionsByQuery(visibleSections, query), [visibleSections, query]);

  return (
    <div className='bravo-ds rlaunch-page contentwrapper'>
      <div className='rlaunch-actions'>
        <div className='rp-count'>
          <b>{total}</b> {countNoun}
        </div>
        <div className='rp-search'>
          <FaIcon iconName='fa-solid fa-magnifying-glass' />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={searchPlaceholder}
          />
          {query ? (
            <button
              className='rp-clear'
              type='button'
              title='Clear search'
              onClick={() => setQuery('')}
            >
              <FaIcon iconName='fa-solid fa-xmark' />
            </button>
          ) : null}
        </div>
      </div>

      <div className='rp-body'>
        {filteredSections.map((section) => (
          <section
            className='rp-section'
            key={section.title}
          >
            <div className='rp-sec-head'>
              <h2>{section.title}</h2>
              <span className='rp-tally'>{section.cards.length}</span>
              <span className='rp-hr' />
            </div>
            <div className='rp-grid'>
              {section.cards.map((card) => (
                <ReportLauncherCard
                  key={card.title}
                  {...card}
                />
              ))}
            </div>
          </section>
        ))}
        {filteredSections.length === 0 ? (
          <div className='empty-state'>
            <div className='ei'>
              <FaIcon iconName='fa-solid fa-magnifying-glass' />
            </div>
            <b>No reports match "{query}"</b>
            <span>Try a different name or format, or clear the search.</span>
            <button
              className='btn'
              type='button'
              onClick={() => setQuery('')}
            >
              <FaIcon iconName='fa-solid fa-eraser' />
              Clear search
            </button>
          </div>
        ) : null}
      </div>
      {overlay}
    </div>
  );
}

export default ReportLauncherPage;
